/* eslint-disable max-len */
import { Calendar } from "@react-admin/ra-calendar";
import dayjs, { Dayjs } from "dayjs";
import { Dispatch, useEffect, useRef } from "react";
import { IShowAppointmentDialogData } from "../../CustomAppointmentList";
import { IShowAppointmentServiceDialogData } from "../../AppointmentServiceList";
// import * as User from "providers/user";
import { ListContextProvider, useList, useTranslate } from "react-admin";
import { getZonedDate } from "../../../utils/helpers";
import { CalendarCheckedIcon } from "assets/Icons";
import { Theme, useMediaQuery } from "@mui/material";

interface RoleArtistCalendarProps {
  date: Dayjs;
  locale: string;
  type: string;
  // select: (arg: any, artistId: string) => void;
  editable?: boolean;
  isPopoverOpen?: boolean;
  handlePopoverOpen?: (note: string) => void;
  handlePopoverClose?: () => void;
  anchorEl?: HTMLElement | null;
  setShowDialogData?: Dispatch<
    React.SetStateAction<
      IShowAppointmentDialogData | IShowAppointmentServiceDialogData | null
    >
  >;
  selectable?: boolean;
  // artistId: string;
  // isPrev: boolean;
  // isNext: boolean;
  // setSelectedCalendarDate: Dispatch<
  //   SetStateAction<{
  //     title: string;
  //     dateForFilter: string;
  //   } | null>
  // >;
  // calendarsDate: Dayjs | null;
  // index: number;
  appointmentServicesData: any[];
  // setCalendarsDate: Dispatch<SetStateAction<dayjs.Dayjs | null>>;
  // businessHours: any;
}

const RoleArtistCalendar = ({
  date,
  locale,
  type,
  // select,
  editable,
  isPopoverOpen,
  handlePopoverOpen,
  handlePopoverClose,
  anchorEl,
  setShowDialogData,
  selectable,
  // isPrev,
  // isNext,
  // setSelectedCalendarDate,
  // calendarsDate,
  // index,
  appointmentServicesData
}: // setCalendarsDate,
// businessHours
// artistId
RoleArtistCalendarProps) => {
  const translate = useTranslate();
  const isSmall = useMediaQuery<Theme>("(max-width:1023px)");
  let calRef = useRef<any>();
  // const { user } = User.useUser();

  const offset = new Date().getTimezoneOffset();
  const hour = offset <= -720 ? 0 : offset >= 720 ? 16 : 12;

  useEffect(() => {
    if (calRef.current) {
      if (date) {
        calRef?.current?.gotoDate(
          date.hour(hour).minute(0).second(0)?.format()
        );
        // setCalendarsDate(null);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [calRef, date]);

  // const offset = new Date().getTimezoneOffset();
  // const hour = offset <= -720 ? 0 : offset >= 720 ? 16 : 12;
  // useEffect(() => {
  //   if (calRef.current) {
  //     setSelectedCalendarDate({
  //       title: calRef?.current?.currentDataManager?.data?.viewTitle,
  //       dateForFilter: JSON.parse(
  //         JSON.stringify(
  //           dayjs(calRef?.current?.currentDataManager?.data?.currentDate)
  //         )
  //       )
  //     });
  //     if (isPrev) {
  //       calRef?.current?.gotoDate(
  //         dayjs(calRef?.current?.currentDataManager?.data?.currentDate)
  //           .hour(hour)
  //           .minute(0)
  //           .second(0)
  //           .subtract(1, "day")
  //           ?.format()
  //       );
  //       localStorage.setItem(
  //         "ServiceCalendarDateFilter",
  //         JSON.stringify(
  //           dayjs(calRef?.current?.currentDataManager?.data?.currentDate)
  //         )
  //       );
  //     }
  //     if (isNext) {
  //       calRef?.current?.gotoDate(
  //         dayjs(calRef?.current?.currentDataManager?.data?.currentDate)
  //           .hour(hour)
  //           .minute(0)
  //           .second(0)
  //           .add(1, "day")
  //           ?.format()
  //       );
  //       localStorage.setItem(
  //         "ServiceCalendarDateFilter",
  //         JSON.stringify(
  //           dayjs(calRef?.current?.currentDataManager?.data?.currentDate)
  //         )
  //       );
  //     }
  //     if (calendarsDate) {
  //       calRef?.current?.gotoDate(
  //         calendarsDate.hour(hour).minute(0).second(0)?.format()
  //       );
  //       setCalendarsDate(null);
  //     }
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [calRef, isPrev, isNext, calendarsDate, setSelectedCalendarDate]);

  const listContext = useList({
    data: appointmentServicesData,
    isLoading: false
  });

  const converter = (event: any) => {
    const price = !!event?.add_ons?.length
      ? event?.service?.price +
        event.add_ons.reduce((acc: number, curr: any) => {
          acc += curr?.core_service?.price;
          return acc;
        }, 0)
      : event?.service?.price;
    const start = getZonedDate(
      event?.start_time,
      event?.appointment?.location?.timezone
    );
    const end = getZonedDate(
      event?.end_time,
      event?.appointment?.location?.timezone
    );
    const timeNow = getZonedDate(
      new Date()?.toISOString(),
      event?.appointment?.location?.timezone
    );
    const guestName =
      event?.person_number > 0
        ? `${event?.user?.first_name}'s friend (P${event?.person_number + 1})`
        : "";
    const durationInMinutes = (end.getTime() - start.getTime()) / (1000 * 60);
    const retval = {
      id: String(event.id),
      title: `${event?.user?.first_name} ${event?.user?.last_name}`,
      start: start.toISOString(),
      end: end.toISOString(),
      extendedProps: {
        artistsIds: event?.artist?.user?.id,
        artistId: event?.artist?.id,
        artistFullName: `${event?.artist?.user?.first_name} ${event?.artist?.user?.last_name}`,
        artistPhoto:
          event?.artist?.cover_photo_url ||
          event?.artist?.user?.photo_url ||
          "monogram",
        clientPhoto: event?.user?.photo_url || "monogram",
        guestName,
        appointmentId: event?.appointment?.id,
        appointmentNotes: event?.appointment?.notes,
        duration: durationInMinutes,
        serviceDuration: event?.service?.duration,
        servicePrice: price,
        serviceName: event?.service?.name,
        locationName:
          event?.appointment?.location?.nickname ||
          event?.appointment?.location?.name,
        addOns: event?.add_ons || [],
        time: `${start.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit"
        })} - ${end.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit"
        })}`,
        startDateAndTime: event?.start_time,
        locationTimezone: event?.appointment?.location?.timezone,
        isBlockedTime: event?.is_blocked_time,
        clientPhoneNumber: event?.user?.phone_number,
        end_time_for_check: end
      },
      backgroundColor: event?.is_blocked_time
        ? "#dbdbdb"
        : end < timeNow
        ? "#F6F4F1"
        : "#C0E7F8",
      borderColor: event?.is_blocked_time ? "#dbdbdb" : "#C0E7F8",
      textColor: event?.is_blocked_time
        ? "#000000"
        : end < timeNow
        ? "rgba(13, 86, 117, 0.7)"
        : "#114B5B",
      editable: false,
      durationEditable: false,
      display: "block",
      duration: durationInMinutes,
      start_time: start,
      end_time: end
    };
    return retval;
  };
  return (
    <div className="bg-[#FAF9F7] rounded-lg">
      <ListContextProvider value={listContext}>
        <Calendar
          locale={locale}
          convertToEvent={converter}
          datesSet={(dateInfo) => (calRef.current = dateInfo?.view?.calendar)}
          // select={select}
          selectable={selectable}
          scrollTime="07:00"
          // businessHours={businessHours}
          // eventChange={(eventChangeInfo) => {
          //   editWithDrag(eventChangeInfo);
          // }}
          // eventClassNames={(args) => {
          //   return args?.event?._def?.extendedProps?.artistsIds?.includes(
          //     artistFilter
          //   )
          //     ? ""
          //     : "event-hidden";
          // }}
          eventContent={(e: any): JSX.Element => {
            if (type === "appointmentService") {
              return (
                <>
                  {e?.event?._def?.extendedProps?.appointmentNotes ? (
                    <>
                      <div
                        id="customEventWrapper"
                        title={
                          e?.event?._def?.extendedProps?.isBlockedTime
                            ? `${translate("appointment.blocked_time")} - ${
                                e?.event?._def?.extendedProps?.time
                              }`
                            : e?.event?._def?.extendedProps?.serviceName +
                              (!!e?.event?._def?.extendedProps?.addOns?.length
                                ? ` (${e?.event?._def?.extendedProps?.addOns
                                    ?.map((item: any) => item.core_service.name)
                                    ?.join(", ")})`
                                : "") +
                              ` - ${
                                e?.event?._def?.extendedProps?.guestName
                                  ? e?.event?._def?.extendedProps?.guestName
                                  : e?.event?._def?.title
                              }` +
                              " - " +
                              e?.event?._def?.extendedProps?.time
                        }
                      >
                        <p
                          id="customEventTime"
                          className={
                            e?.event?._def?.extendedProps?.duration > 30
                              ? "line-clamp-2"
                              : "line-clamp-1"
                          }
                        >
                          {e?.event?._def?.extendedProps?.isBlockedTime
                            ? ""
                            : e?.event?._def?.extendedProps?.serviceName}
                          {e?.event?._def?.extendedProps?.isBlockedTime
                            ? ""
                            : !!e?.event?._def?.extendedProps?.addOns?.length
                            ? ` (${e?.event?._def?.extendedProps?.addOns
                                ?.map((item: any) => item.core_service.name)
                                ?.join(", ")})`
                            : ""}
                        </p>
                        <p id="customEventTitle">
                          {e?.event?._def?.extendedProps?.isBlockedTime
                            ? translate("appointment.blocked_time")
                            : e?.event?._def?.extendedProps?.guestName
                            ? e?.event?._def?.extendedProps?.guestName
                            : e?.event?._def?.title}
                        </p>
                        <p id="customEventTime">
                          {e?.event?._def?.extendedProps?.time}
                        </p>
                      </div>
                      <div
                        id="customEventNote"
                        style={{
                          backgroundColor:
                            e?.event?._def?.extendedProps?.duration > 0 &&
                            e?.event?._def?.extendedProps?.duration < 30
                              ? "#FFB469"
                              : e?.event?._def?.extendedProps?.duration > 30 &&
                                e?.event?._def?.extendedProps?.duration < 61
                              ? "#93E1F4"
                              : "#F99C75"
                        }}
                        aria-owns={
                          isPopoverOpen ? "mouse-over-popover" : undefined
                        }
                        aria-haspopup="true"
                        onMouseEnter={() =>
                          handlePopoverOpen &&
                          handlePopoverOpen(
                            e?.event?._def?.extendedProps?.appointmentNotes
                          )
                        }
                        onMouseLeave={handlePopoverClose}
                      />
                    </>
                  ) : (
                    <div
                      id="customEventWrapper"
                      title={
                        e?.event?._def?.extendedProps?.isBlockedTime
                          ? `${translate("appointment.blocked_time")} - ${
                              e?.event?._def?.extendedProps?.time
                            }`
                          : e?.event?._def?.extendedProps?.serviceName +
                            (!!e?.event?._def?.extendedProps?.addOns?.length
                              ? ` (${e?.event?._def?.extendedProps?.addOns
                                  ?.map((item: any) => item.core_service.name)
                                  ?.join(", ")})`
                              : "") +
                            ` - ${
                              e?.event?._def?.extendedProps?.guestName
                                ? e?.event?._def?.extendedProps?.guestName
                                : e?.event?._def?.title
                            }` +
                            " - " +
                            e?.event?._def?.extendedProps?.time
                      }
                    >
                      <p
                        id="customEventTime"
                        className={
                          e?.event?._def?.extendedProps?.duration > 30
                            ? "line-clamp-2"
                            : "line-clamp-1"
                        }
                      >
                        {e?.event?._def?.extendedProps?.isBlockedTime
                          ? ""
                          : e?.event?._def?.extendedProps?.serviceName}
                        {e?.event?._def?.extendedProps?.isBlockedTime
                          ? ""
                          : !!e?.event?._def?.extendedProps?.addOns?.length
                          ? ` (${e?.event?._def?.extendedProps?.addOns
                              ?.map((item: any) => item.core_service.name)
                              ?.join(", ")})`
                          : ""}
                      </p>
                      <p id="customEventTitle">
                        {e?.event?._def?.extendedProps?.isBlockedTime
                          ? translate("appointment.blocked_time")
                          : e?.event?._def?.extendedProps?.guestName
                          ? e?.event?._def?.extendedProps?.guestName
                          : e?.event?._def?.title}
                      </p>
                      <p id="customEventTime">
                        {e?.event?._def?.extendedProps?.time}
                      </p>
                    </div>
                  )}
                  {e?.event?._def?.extendedProps?.end_time_for_check <
                    getZonedDate(
                      new Date()?.toISOString(),
                      e?.event?._def?.extendedProps?.locationTimezone
                    ) && (
                    <div id="CalendarCheckedIcon">
                      <CalendarCheckedIcon />
                    </div>
                  )}
                </>
              );
            }
            return <div />;
          }}
          editable={editable}
          mutationMode="optimistic"
          height={isSmall ? "2790px" : "calc(100dvh - 246px)"}
          // headerToolbar={{
          //   left: "",
          //   center: "",
          //   right: ""
          // }}
          headerToolbar={{
            left: "",
            center: "",
            right: "dayGridMonth timeGridWeek timeGridDay"
          }}
          initialView={"timeGridDay"}
          nowIndicator={true}
          eventClick={(e) => {
            if (type === "appointmentService" && setShowDialogData) {
              if (anchorEl) return;
              setShowDialogData({
                id: e?.event?._def?.publicId,
                client: e?.event?._def?.title,
                time: e?.event?._def?.extendedProps?.time,
                artistId: e?.event?._def?.extendedProps?.artistId,
                artist: e?.event?._def?.extendedProps?.artistFullName,
                serviceName: e?.event?._def?.extendedProps?.serviceName,
                date: dayjs(e?.event?._def?.extendedProps?.start_time).format(
                  "D MMMM YYYY (dddd)"
                ),
                artistPhoto: e?.event?._def?.extendedProps.artistPhoto,
                clientPhoto: e?.event?._def?.extendedProps.clientPhoto,
                guestName: e?.event?._def?.extendedProps.guestName,
                appointmentId: e?.event?._def?.extendedProps.appointmentId,
                appointmentNotes:
                  e?.event?._def?.extendedProps.appointmentNotes,
                serviceDuration: e?.event?._def?.extendedProps?.duration,
                servicePrice: e?.event?._def?.extendedProps?.servicePrice,
                locationName: e?.event?._def?.extendedProps?.locationName,
                addOns: e?.event?._def?.extendedProps?.addOns,
                startDateAndTime:
                  e?.event?._def?.extendedProps?.startDateAndTime,
                locationTimezone:
                  e?.event?._def?.extendedProps?.locationTimezone,
                isBlockedTime: e?.event?._def?.extendedProps?.isBlockedTime,
                clientPhoneNumber:
                  e?.event?._def?.extendedProps?.clientPhoneNumber
              });
            }
          }}
          slotDuration="00:15:00"
          slotLabelInterval="01:00"
          sx={{
            backgroundColor: "#FAF9F7",
            padding: "0px 16px",
            borderRadius: "8px",
            "& .fc-toolbar.fc-header-toolbar": {
              // height: "12px !important"
              marginBottom: "12px"
              // maxHeight: user.impersonate_company_id ? "94px" : "54px",
              // minHeight: user.impersonate_company_id ? "94px" : "54px",
              // display: "none"
            },
            "& .fc-daygrid-body-natural": {
              display: "none" // remove all day section row
            },
            "& .fc-timegrid-divider": {
              display: "none" // remove short empty space below all day section row
            },
            "& .fc-toolbar-title": {
              color: "rgba(48, 47, 46, 0.6)",
              fontSize: "18px",
              lineHeight: "31px",
              verticalAlign: "middle",
              fontWeight: "500",
              fontFamily: "Inter",
              textTransform: "uppercase",
              display: "inline-block"
            },
            "& .fc .fc-scrollgrid-section-liquid > td": {
              borderBottomRightRadius: "8px",
              borderBottomLeftRadius: "8px"
            },
            "& .fc-timegrid-slot-label-cushion": {
              color: "rgba(48, 47, 46, 0.6)",
              fontSize: "12px",
              fontWeight: "400",
              fontFamily: "Inter",
              textTransform: "uppercase"
            },
            "& .fc-daygrid-day-number": {
              color: "rgba(48, 47, 46, 0.6)",
              fontSize: "18px",
              fontWeight: "400",
              fontFamily: "Inter"
            },
            "& .fc-col-header-cell-cushion": {
              color: "rgba(48, 47, 46, 0.6)",
              fontSize: "12px",
              fontWeight: "400",
              fontFamily: "Inter",
              textTransform: "uppercase"
            },
            "& .fc-button": {
              display: "none",
              backgroundColor: "#F6F4F1",
              color: "rgba(48, 47, 46, 0.95)",
              borderColor: "#ddd !important",
              fontSize: "13px",
              fontWeight: 400,
              textTransform: "capitalize",
              borderRadius: "24px",
              lineHeight: "18px",
              fontFamily: "Inter"
            },
            "& .fc-button-primary:disabled": {
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.07)",
                color: "rgba(0, 0, 0, 0.54)"
              }
            },
            "& .fc-button:hover": {
              borderColor: "#ddd !important",
              backgroundColor: "rgba(184, 114, 42, 0.07)",
              color: "rgba(48, 47, 46, 0.95)"
            },
            "& .fc-button-primary:not(:disabled):active": {
              backgroundColor: "rgba(184, 114, 42, 0.1)",
              color: "rgba(48, 47, 46, 0.95)"
            },
            "& .fc-button-primary:not(:disabled).fc-button-active": {
              backgroundColor: "#B8722A",
              "&:hover": {
                backgroundColor: "#B8722A"
              },
              color: "#ffffff",
              borderColor: "#B8722A !important"
            },
            "& .fc-today-button": {
              marginLeft: "0px !important"
            },
            "& .fc-scrollgrid-liquid": {
              borderRadius: "8px"
            },
            "& .fc-theme-standard .fc-scrollgrid": {
              border: "0px !important"
            },
            "& .fc-theme-standard th": {
              border: "0px !important"
            },
            "& .fc-theme-standard td": {
              // borderTopRightRadius: "8px",
              borderLeft: "0px",
              borderRight: "0px"
            },
            "& .fc-theme-standard th:first-child": {
              // borderTop: "0px"
            },
            "& .fc-theme-standard td:last-child": {
              borderBottom: "0px"
            },
            "& .fc-scroller": {
              overflow: "hidden auto !important"
            },
            "& .fc-day-today": {
              backgroundColor: "#FAF9F7 !important"
              // borderRadius: "0px !important"
            },

            "& .fc-prev-button": {
              position: "absolute",
              top: "109px",
              left: "0px",
              padding: "5px 10px 5px 11px",
              zIndex: 10,
              borderColor: "#ddd !important",
              borderBottom: "none",
              borderRight: "none",
              borderRadius: 0,
              borderTopLeftRadius: "8px",
              backgroundColor: "transparent",
              color: "rgba(48, 47, 46, 0.38)"
            },
            "& .fc-next-button": {
              position: "absolute",
              top: "109px",
              right: "0px",
              padding: "5px 10px 5px 11px",
              zIndex: 10,
              borderColor: "#ddd !important",
              borderBottom: "none",
              borderLeft: "none",
              borderRadius: 0,
              borderTopRightRadius: "8px",
              backgroundColor: "transparent",
              color: "rgba(48, 47, 46, 0.38)"
            },
            "& .fc-timegrid-event-harness-inset .fc-timegrid-event, .fc-timegrid-event.fc-event-mirror, .fc-timegrid-more-link":
              {
                boxShadow: "0px 0px 0px 1px #F6F4F1",
                // border: "none",
                borderRadius: "8px",
                padding: "4px"
              },
            "& .fc-theme-standard .fc-popover": {
              backgroundColor: "#ffffff !important"
            },
            "& #customEventWrapper": {
              position: "sticky",
              top: "0px",
              bottom: "0px",
              maxHeight: "100%",
              overflow: "hidden"
            },
            "& #customEventTitle": {
              fontSize: "15px",
              fontWeight: 600,
              fontFamily: "Inter",
              lineHeight: "18px"
            },
            "& #customEventGroupBooking": {
              fontSize: "15px",
              fontWeight: 600,
              fontFamily: "Inter",
              lineHeight: "18px",
              textTransform: "uppercase"
            },
            "& #customEventTime": {
              fontSize: "12px",
              fontWeight: 500,
              fontFamily: "Inter",
              lineHeight: "14px"
            },
            "& #customEventNote": {
              height: "10px",
              width: "10px",
              position: "absolute",
              top: "-6px",
              left: "-5px",
              zIndex: "inherit"
            },
            "& #CalendarCheckedIcon": {
              position: "absolute",
              top: "5px",
              right: "5px",
              zIndex: "inherit"
            },
            "& .fc-daygrid-more-link": {
              fontFamily: "Inter"
            },
            "& .fc-highlight": {},
            "& .event-hidden": {
              display: "none"
            },
            "& .fc-v-event": {
              borderWidth: "2px"
            },
            "& .fc .fc-timegrid-slot-label": {
              border: "none !important"
            },
            "& .fc-direction-ltr .fc-timegrid-slot-label-frame": {
              textAlign: "center",
              marginTop: "-30px !important"
            },
            "& .fc .fc-scroller-liquid-absolute": {
              paddingTop: "10px"
            }
          }}
        />
      </ListContextProvider>
    </div>
  );
};

export default RoleArtistCalendar;
